export default __webpack_public_path__ + "static/media/office.b4723e0f.svg";